import Layout from '@/layout/index.vue'
export const investRouter = [
  // {
  //   path: '/sub-app-radar',
  //   component: Layout,
  //   resourceId: '30',
  //   meta: {
  //     title: '市场雷达',
  //     activeMenu: '/marketRadar',
  //     sort: 14
  //   },

  //   children: [
  //     {
  //       path: '',
  //       component: () => import(/* webpackChunkName: "marketRadar" */ '@/views/marketRadar/index.vue'),
  //       name: '/sub-app-radar',
  //       meta: {
  //         title: '市场雷达',
  //         icon: 'el-icon-s-promotion',
  //         activeMenu: '/marketRadar',
  //         code: 30,
  //         routerBase: '/sub-app-radar'
  //       }
  //     },
  //     {
  //       path: '*',
  //       component: () => import(/* webpackChunkName: "marketRadar" */ '@/views/marketRadar/index.vue'),
  //       meta: {
  //         title: '市场雷达',
  //         icon: 'el-icon-s-promotion',
  //         activeMenu: '/marketRadar',
  //         hidden: true,
  //         routerBase: '/sub-app-radar'
  //       }
  //     }
  //   ]
  // },

  {
    path: '/sub-radar-board',
    component: Layout,
    resourceId: '30',
    meta: {
      title: '市场雷达',
      activeMenu: '/sub-radar-board',
      sort: 14,
      offType: 'marketRadar'
    },

    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "sub-radar-board" */ '@/views/manage/dashBi/radarBoard.vue'),
        name: '/sub-radar-board',
        meta: {
          title: '市场雷达',
          icon: 'el-icon-s-promotion',
          activeMenu: '/sub-radar-board',
          code: 30,
          routerBase: '/sub-radar-board',
          offType: 'marketRadar'
        }
      },
      {
        path: '*',
        component: () => import(/* webpackChunkName: "sub-radar-board" */ '@/views/manage/dashBi/radarBoard.vue'),
        meta: {
          title: '市场雷达',
          icon: 'el-icon-s-promotion',
          activeMenu: '/sub-radar-board',
          hidden: true,
          routerBase: '/sub-radar-board',
          offType: 'marketRadar'
        }
      }
    ]
  },

  {
    path: '/assetsConfig',
    resourceId: '20',
    parentId: null,
    meta: {
      title: '机构研究',
      activeMenu: '/assetsConfig',
      sort: 15,
      offType: 'assets'
    },
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "assetsConfig" */ '@/views/assetsConfig/index.vue'),
        meta: {
          title: '机构研究',
          activeMenu: '/assetsConfig',
          icon: 'asset_plan',
          code: 20,
          offType: 'assets'
        }
      }
    ]
  },
  {
    path: '/portfolio',
    resourceId: '12',
    parentId: null,
    component: Layout,
    meta: {
      title: '投资规划',
      hidden: false,
      activeMenu: '/portfolio',
      offType: 'invest',
      sort: 16
    },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "portfolio_groupOne" */ '@/views/portfolio/index.vue'),
        meta: {
          title: '投资规划',
          icon: 'invest_plan',
          activeMenu: '/portfolio',
          offType: 'invest',
          code: 12
        }
      },
      {
        path: 'portkyc/plan',
        component: () => import(/* webpackChunkName: "portKYC" */ '@/views/portfolio/portKYC/index.vue'),
        meta: {
          title: '投资规划',
          icon: 'form',
          hidden: true,
          activeMenu: '/portfolio',
          offType: 'invest'
        }
      },
      {
        path: 'group1',
        component: () => import(/* webpackChunkName: "portfolio_groupOne" */ '@/views/portfolio/index.vue'),
        meta: {
          title: '投资规划',
          icon: 'form',
          hidden: true,
          activeMenu: '/portfolio',
          offType: 'invest'
        }
      },
      {
        path: 'group2',
        resourceId: '1204',
        parentId: '12',
        component: () => import(/* webpackChunkName: "portfolio_aloneIndex" */ '@/views/portfolio/groupTwo/index.vue'),
        meta: {
          title: '产品选择',
          icon: 'form',
          hidden: true,
          activeMenu: '/portfolio',
          offType: 'invest'
        }
      },
      {
        activeMenu: '/portfolio',
        path: 'group3',
        component: () => import(/* webpackChunkName: "portfolio_groupThree" */ '@/views/portfolio/groupThree/index.vue'),
        meta: {
          title: '投资产品回测',
          icon: 'form',
          hidden: true,
          activeMenu: '/portfolio',
          offType: 'invest'
        }
      }
    ]
  },
  {
    path: '/otherOpt',
    resourceId: '23',
    parentId: null,
    component: Layout,
    meta: {
      title: '财富聚焦',
      activeMenu: '/otherOpt',
      sort: 17,
      offType: 'wealth'
    },
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import(/* webpackChunkName: "otherOpt" */ '@/views/otherOption/index.vue'),
        meta: {
          title: '财富聚焦',
          activeMenu: '/otherOpt',
          sort: 9,
          icon: 'el-icon-s-shop',
          code: 23,
          offType: 'wealth'
        }
      },
      {
        path: 'otherOptDetail',
        name: 'otherOptDetail',
        component: () => import(/* webpackChunkName: "otherOpt" */ '@/views/otherOption/otherOptionDetail.vue'),
        meta: {
          title: '财富聚焦详情',
          activeMenu: '/otherOpt',
          hidden: true,
          offType: 'wealth'
        }
      },
    ]
  },
  // {
  //   path: '/sub-app-house',
  //   component: Layout,
  //   resourceId: '31',
  //   meta: {
  //     title: '房产看板',
  //     activeMenu: '/house',
  //     sort: 18,
  //   },

  //   children: [
  //     {
  //       path: '',
  //       component: () => import(/* webpackChunkName: "marketRadar" */ '@/views/marketRadar/house.vue'),
  //       meta: {
  //         title: '房产看板',
  //         icon: 'el-icon-office-building',
  //         activeMenu: '/house',
  //         code: 31,
  //         routerBase: '/sub-app-house'
  //       }
  //     },
  //     {
  //       path: '*',
  //       component: () => import(/* webpackChunkName: "marketRadar" */ '@/views/marketRadar/house.vue'),
  //       meta: {
  //         title: '房产看板',
  //         icon: 'el-icon-office-building',
  //         activeMenu: '/house',
  //         routerBase: '/sub-app-house',
  //         hidden: true
  //       }
  //     }
  //   ]
  // },
  {
    path: '/sub-house-board',
    component: Layout,
    resourceId: '31',
    meta: {
      title: '房产看板',
      activeMenu: '/sub-house-board',
      sort: 18,
      offType: 'house'
    },

    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "sub-house-board" */ '@/views/manage/dashBi/houseBoard.vue'),
        name: '/sub-house-board',
        meta: {
          title: '房产看板',
          icon: 'el-icon-office-building',
          activeMenu: '/sub-house-board',
          code: 31,
          routerBase: '/sub-house-board',
          offType: 'house'
        }
      },
      {
        path: '*',
        component: () => import(/* webpackChunkName: "sub-house-board" */ '@/views/manage/dashBi/houseBoard.vue'),
        meta: {
          title: '房产看板',
          icon: 'el-icon-office-building',
          activeMenu: '/sub-house-board',
          hidden: true,
          routerBase: '/sub-house-board',
          offType: 'house'
        }
      }
    ]
  },
  {
    path: '/basicSecurity',
    resourceId: '13',
    parentId: null,
    component: Layout,
    meta: {
      title: '保障规划',
      activeMenu: '/basicSecurity',
      sort: 20,
      offType: 'basic'
    },
    children: [
      {
        path: 'index',

        component: () => import(/* webpackChunkName: "basicSecurity" */ '@/views/basicSecurity/financialAnalysis/index.vue'),
        meta: {
          title: '保障规划',
          icon: 'family_plan',
          activeMenu: '/basicSecurity',
          code: 13,
          offType: 'basic'
        }
      },
      {
        path: 'basicKyc',

        component: () => import(/* webpackChunkName: "basicSecurity" */ '@/views/basicSecurity/index.vue'),
        meta: {
          title: '资产相关',
          icon: 'form',
          hidden: true,
          activeMenu: '/basicSecurity',
          offType: 'basic'
        }
      },
      {
        path: 'base',
        component: () => import(/* webpackChunkName: "basicSecurity" */ '@/views/basicSecurity/base.vue'),
        meta: {
          title: '保障规划',
          icon: 'form',
          hidden: true,
          activeMenu: '/basicSecurity',
          offType: 'basic'
        }
      },
      {
        path: 'basePlanDetail',
        component: () => import(/* webpackChunkName: "basePlanDetail" */ '@/views/basicSecurity/basePlanDetail.vue'),
        meta: {
          title: '保障规划',
          icon: 'form',
          hidden: true,
          activeMenu: '/basicSecurity',
          offType: 'basic'
        }
      }
    ]
  },
  {
    path: '/childTeach',
    resourceId: '14',
    parentId: null,
    component: Layout,
    meta: {
      title: '教育规划',
      activeMenu: '/childTeach',
      offType: 'childEdu',
      sort: 21
    },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "childTeach" */ '@/views/childTeach/index.vue'),
        meta: {
          title: '教育规划',
          activeMenu: '/childTeach',
          icon: 'child_plan',
          offType: 'childEdu',
          code: 14

        }
      }, {
        path: 'child2',
        component: () => import(/* webpackChunkName: "asKYC" */ '@/views/childTeach/template/twoIndex.vue'),
        meta: {
          title: '资产相关',
          icon: 'form',
          activeMenu: '/childTeach',
          hidden: true,
          offType: 'childEdu'
        }
      }, {
        path: 'child3',
        component: () => import(/* webpackChunkName: "childTeach" */ '@/views/childTeach/template/three/index.vue'),
        meta: {
          title: '子女教育保障规划',
          icon: 'form',
          activeMenu: '/childTeach',
          hidden: true,
          offType: 'childEdu'
        }
      }, {
        path: 'child3_others',
        component: () => import(/* webpackChunkName: "childTeach" */ '@/views/childTeach/template/three/others.vue'),
        meta: {
          title: '子女教育保障规划',
          icon: 'form',
          activeMenu: '/childTeach',
          hidden: true,
          offType: 'childEdu'
        }
      }
    ]
  },
  {
    path: '/pension',
    resourceId: '15',
    parentId: null,
    component: Layout,
    redirect: '/pension/card/cover',
    meta: {
      title: '退休规划',
      activeMenu: '/pension',
      offType: 'pension',
      sort: 22
    },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "newPension" */ '@/views/newPension/index.vue'),
        meta: {
          title: '退休规划',
          icon: 'pession_plan',
          activeMenu: '/pension',
          offType: 'pension',
          code: 15

        }
      },
      {
        path: 'card/:type',
        component: () => import(/* webpackChunkName: "newPension" */ '@/views/newPension/index.vue'),
        meta: {
          hidden: true,
          title: '退休规划组',
          activeMenu: '/pension',
          sort: 1,
          offType: 'pension'
        }
      },
      {
        path: 'test',
        component: () => import(/* webpackChunkName: "newPension" */ '@/views/newPension/test.vue'),
        meta: {
          hidden: true,
          title: '退休规划',
          icon: 'pession_plan',
          activeMenu: '/pension',
          offType: 'pension'
        }
      },
      {
        path: 'investPro',
        component: () => import(/* webpackChunkName: "newPension" */ '@/views/newPension/pensionCard/investCard/inputPage.vue'),
        meta: {
          hidden: true,
          title: '退休规划',
          icon: 'pession_plan',
          activeMenu: '/pension',
          offType: 'pension'
        }
      },
      // {
      //   path: 'index',
      //   component: () => import(/* webpackChunkName: "pension" */ '@/views/pension/financialAnalysis/index.vue'),
      //   meta: {
      //     title: '退休规划',
      //     icon: 'pession_plan',
      //     activeMenu: '/pension',
      //     offType: 'pension'

      //   }
      // },
      // {
      //   path: 'typein',

      //   component: () => import(/* webpackChunkName: "pensionType" */ '@/views/pension/index.vue'),
      //   meta: {
      //     title: '退休规划',
      //     icon: 'form',
      //     activeMenu: '/pension',
      //     hidden: true,
      //     offType: 'pension'
      //   }
      // },
      // {
      //   path: 'plan',

      //   component: () => import(/* webpackChunkName: "pensionPlan" */ '@/views/pension/plan/index.vue'),
      //   meta: {
      //     title: '退休规划',
      //     icon: 'form',
      //     activeMenu: '/pension',
      //     hidden: true,
      //     offType: 'pension'
      //   }
      // },
      // {
      //   path: 'planDetail',

      //   component: () => import(/* webpackChunkName: "pensionPlanDetail" */ '@/views/pension/planDetail/index.vue'),
      //   meta: {
      //     title: '退休规划',
      //     icon: 'form',
      //     activeMenu: '/pension',
      //     hidden: true,
      //     offType: 'pension'
      //   }
      // }
    ]
  },
  {
    path: '/analys',
    component: Layout,
    resourceId: '11',
    parentId: null,
    meta: {
      title: '财富体检',
      activeMenu: '/analys',
      offType: 'assetAnalysis',
      sort: 24
    },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "financialAnalysis" */ '@/views/analys/financialAnalysis/index.vue'),
        meta: {
          title: '财富体检',
          icon: 'el-icon-data-analysis',
          activeMenu: '/analys',
          offType: 'assetAnalysis',
          code: 11
        }
      },
      {
        path: 'portkyc/analy',
        component: () => import(/* webpackChunkName: "portKYC" */ '@/views/portfolio/portKYC/index.vue'),
        meta: {
          title: '投资规划',
          icon: 'form',
          hidden: true,
          activeMenu: '/analys',
          offType: 'invest'
        }
      },
      {
        path: 'analyChart',
        component: () => import(/* webpackChunkName: "asKYC" */ '@/views/analys/analyChart/index.vue'),
        meta: {
          title: '家庭资产总览',
          hidden: true,
          activeMenu: '/analys',
          offType: 'assetAnalysis'
        }
      }
    ]
  }
]
